import React, { useEffect } from 'react';
import { JumpLink } from '../../../ui';
import styled from 'styled-components';
import { screenSmMax } from '@spotify-internal/encore-web';
const StyledJumpLinkNav = styled.div `
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
  justify-content: space-between;
  column-gap: 24px;

  @media (max-width: ${screenSmMax}) {
    height: auto;
    grid-auto-flow: row;
    row-gap: 8px;
    padding-bottom: 8px;
  }
`;
export const JumpLinkNav = React.forwardRef(({ jumpLinks, backgroundColor, textColor, hoverBackground, useNumberedJumpLinks = false, eyebrowOrHeadline = false, }, _) => {
    const jumpLinkRefs = [];
    const [tallest, setTallest] = React.useState(0);
    const [tallestHeadline, setTallestHeadline] = React.useState(0);
    useEffect(() => {
        const handleResize = () => {
            let newTallest = 0;
            let newTallestHeadline = 0;
            document.querySelectorAll('.jl').forEach(jl => {
                if (jl.children[0].clientHeight > newTallest)
                    newTallest = jl.children[0].clientHeight;
            });
            document.querySelectorAll('.jl-headline').forEach(hl => {
                for (let i = 0; i < hl.children.length; i++) {
                    if (hl.children[i].clientHeight > newTallestHeadline) {
                        newTallestHeadline = hl.children[i].clientHeight;
                    }
                }
            });
            setTallestHeadline(newTallestHeadline);
            setTallest(newTallest);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    });
    return (React.createElement(StyledJumpLinkNav, null, jumpLinks.map((jl, idx) => {
        const ref = React.createRef();
        const shouldUseJumpLinkNumber = useNumberedJumpLinks || jl.eyebrowNumber;
        jumpLinkRefs.push(ref);
        return (React.createElement(JumpLink, Object.assign({}, jl, { key: idx, ref: ref, backgroundColor: backgroundColor, textColor: textColor, hoverBackground: hoverBackground, jumpLinkNumber: shouldUseJumpLinkNumber ? idx + 1 : undefined, link: jl.module ? undefined : `#${`${jl.id}-${jl.contentType}`}`, eyebrowOrHeadline: eyebrowOrHeadline, height: tallest, tallestHeadline: tallestHeadline })));
    })));
});
//# sourceMappingURL=JumpLinkNav.js.map